const PAGES = {
  main: '/',
  authors: '/authors',
  author: '/authors/:author',
  pieces: '/pieces',
  piece: '/pieces/:id',
  issue: '/issues/:id',
  issues: '/issues',
  books: '/books',
  contacts: '/contacts',
  admin: '/admin',
  draft: '/drafts/:id'
};

export default PAGES;